<template>
    <svg
      width="16"
      height="16"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.48288 7.71558H2.01724C1.73158 7.71558 1.5 7.48401 1.5 7.19834V5.388C1.5 4.81667 1.96315 4.35352 2.53448 4.35352H7.96564C8.53697 4.35352 9.00012 4.81667 9.00012 5.388V7.19834C9.00012 7.48401 8.76855 7.71558 8.48288 7.71558Z"
        :stroke="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.43967 6.0345C3.43967 6.17733 3.32388 6.29312 3.18105 6.29312C3.03821 6.29312 2.92242 6.17733 2.92242 6.0345C2.92242 5.89167 3.03821 5.77588 3.18105 5.77588C3.32388 5.77588 3.43967 5.89167 3.43967 6.0345Z"
        :stroke="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.57761 6.0345C7.57761 6.17733 7.46182 6.29312 7.31898 6.29312C7.17615 6.29312 7.06036 6.17733 7.06036 6.0345C7.06036 5.89167 7.17615 5.77588 7.31898 5.77588C7.46182 5.77588 7.57761 5.89167 7.57761 6.0345Z"
        :stroke="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.48285 4.35345H2.01721L2.39038 2.11441C2.47352 1.6156 2.9051 1.25 3.41079 1.25H7.08927C7.59497 1.25 8.02654 1.6156 8.10968 2.11441L8.48285 4.35345Z"
        :stroke="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.53448 7.97412V8.74998"
        :stroke="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.96552 7.97412V8.74998"
        :stroke="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
</template>
<script>
import {DEFAULT_BRAND_COLOR} from '../constants';

export default {
  inject: ['getBrandPrimaryBackground'],
  computed: {
    stroke() {
      const stroke = this.getBrandPrimaryBackground();
      return stroke || DEFAULT_BRAND_COLOR;
    },
  },
};
</script>
